import { render, staticRenderFns } from "./AllowancesPlanDelete.vue?vue&type=template&id=69d8c1ac&scoped=true&"
import script from "./AllowancesPlanDelete.vue?vue&type=script&lang=js&"
export * from "./AllowancesPlanDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d8c1ac",
  null
  
)

export default component.exports